import {
  createContext,
  Dispatch,
  SetStateAction,
  useEffect,
  useState,
} from 'react'
import { Loading } from '../../components/Loading/Loading'

import { apiService } from '../../services/_config_/apiservice'

type ContextType = {
  authentified: boolean
  loading: boolean
  setAuthentified: Dispatch<SetStateAction<boolean>>
}

export const AuthContext = createContext<ContextType>({
  authentified: false,
  loading: true,
  setAuthentified: () => {},
})

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [loading, setLoading] = useState(true)
  const [authentified, setAuthentified] = useState<boolean>(false)

  useEffect(() => {
    const token = localStorage.getItem('token')
    if (token) {
      const tokenConvert = JSON.parse(token)
      apiService.defaults.headers.common.Authorization = `${tokenConvert.type} ${tokenConvert.token}`

      setAuthentified(true)
    } else {
      setAuthentified(false)
    }
    setLoading(false)
  }, [])

  if (loading) {
    return <Loading contrast={false} />
  }
  return (
    <AuthContext.Provider
      value={{
        authentified,
        loading,
        setAuthentified,
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}
